export default __webpack_public_path__ + "static/bg-numbers--mobile-402a0331b7a331d639c9d0ad8f20b012.jpg";